export const colors = {
  bg: '#F7F6F2',
  surface: '#FFFFFF',
  surface2: '#FBFAF6',
  ink: '#111114',
  ink2: '#45464B',
  ink3: '#7A7B82',
  line: '#EDEBE4',
  line2: '#E2DFD6',
  cream: '#FDFBEE',
  accent: '#3B2AFF',
  accentInk: '#0C0842',
  accentSoft: '#EDEAFE',
  good: '#0E8C4A',
  goodSoft: '#E6F3EB',
  warn: '#C46A00',
  warnSoft: '#FBEED6',
  bad: '#B0331C',
  badSoft: '#F7E4DE',
  lilac: '#EDEAFE',
  butter: '#FDF3D3',
  mint: '#DDEFE2',
  peach: '#F8DFD0',
} as const;

export const radius = {
  xs: 8,
  sm: 12,
  md: 18,
  pill: 999,
} as const;

export const space = {
  0.5: 2,
  1: 4,
  1.5: 6,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
} as const;

export const fontFamily = {
  sans: "'Inter', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
} as const;

export const fontFeature = "'cv11', 'ss01', 'ss03'";

export const fontSize = {
  xs: 10,
  sm: 11,
  base: 14,
  md: 16,
  lg: 18,
  xl: 22,
  '2xl': 26,
  '3xl': 32,
  '4xl': 42,
  '5xl': 54,
} as const;

export const fontWeight = {
  regular: '400',
  medium: '500',
  semibold: '600',
} as const;

export const shadow = {
  md: '0 1px 0 rgba(17,17,20,0.02), 0 6px 20px -10px rgba(17,17,20,0.08)',
  lg: '0 12px 40px -12px rgba(17,17,20,0.14), 0 2px 8px rgba(17,17,20,0.04)',
} as const;

export type Tone = 'default' | 'soft' | 'subtle' | 'accent';
export const toneColor: Record<Tone, string> = {
  default: colors.ink,
  soft: colors.ink2,
  subtle: colors.ink3,
  accent: colors.accent,
};
